import { createContext } from 'react'

export const AuthContext = createContext({
  userRole: null,
  userId: null,
  token: null,
  roleLoading: true,
  login: () => {},
  logout: () => {},
})
